import { useState, useContext } from "react";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { DiscoveryContext } from "../discovery-context";
import MUICard from "./../../../Component/UI/MUICard/MUICard";
import MUIIconButton from "./../../../Component/UI/MUIIconButton/MUIIconButton";
import classes from "./CompetitorItem.module.css";
import Modal from "../../../Component/Modal/Modal";
import BrandIndexBreakups from "../../../Component/BrandIndexHistory/BrandIndexBreakups";
import ErrorView from "../../../Component/ErrorView/ErrorView";
import AnimatedNumber from "./../../../Component/AnimatedNumber/AnimatedNumber";
import ProductVariant from "./../ProductVariant";
import { Skeleton } from "@mui/material";

function extractDomain(input) {
  if (/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(input)) {
    return input;
  }
  try {
    if (!/^https?:\/\//i.test(input)) {
      input = "http://" + input;
    }
    const urlObject = new URL(input);
    let hostname = urlObject.hostname;
    const parts = hostname.split(".");

    if (parts.length > 2) {
      hostname = parts.slice(-2).join(".");
    }

    return hostname;
  } catch (error) {
    console.error("Invalid input:", error.message);
    return null;
  }
}

export default function CompetitorItem({
  competitor,
  brandIndex,
  isHighestFavorability= false,
  brand,
  index,
  onRetry = () => {},
}) {
  const [showBrandIndexBreakups, setShowBrandIndexBreakups] = useState(false);

  const discoveryCtx = useContext(DiscoveryContext);

  const ctxCompetitor = discoveryCtx.competitors
    .filter((comp) => comp.name != brand)
    .find((comp) => comp.name === competitor);

  let domain = "";
  if (ctxCompetitor && ctxCompetitor?.domain) {
    domain = extractDomain(ctxCompetitor?.domain);
  }

  const variants = ctxCompetitor?.variants
    ? ctxCompetitor.variants.filter((variant) => variant.active)
    : [];

  let cardContent = "";
  if (competitor && !brandIndex?.error && brandIndex.total) {
    cardContent = (
      <>
        {!competitor && (
          <div className={classes.add_container}>
            <MUIIconButton size="large">
              <AddCircleOutlineOutlinedIcon
                style={{ fontSize: 40 }}
                fontSize="large"
              />
            </MUIIconButton>
          </div>
        )}
        {brandIndex?.extras && (
          <MUIIconButton
            data-html2canvas-ignore
            onClick={() => setShowBrandIndexBreakups(true)}
            className={classes.settings}
            id={isHighestFavorability ? "competitor_sentiment" : undefined}
          >
            <InfoOutlinedIcon />
          </MUIIconButton>
        )}
        <div className={classes.header}>
          <img
            data-html2canvas-ignore
            className={classes.logo}
            src={`https://img.logo.dev/${domain}?token=pk_SaDf4t2eRsW5Fc84zgJRZA`}
          />
          <div className={classes.title_container}>
            <span className={classes.title}>{competitor}</span>
            {variants.length > 0 && (
              <ProductVariant variants={variants} editable={false}>
                <span className={classes.variant_text}>
                  {variants.length} variants
                </span>
              </ProductVariant>
            )}
          </div>
        </div>
        <div className={classes.content}>
          <AnimatedNumber
            className={classes.score}
            start={0}
            end={brandIndex?.total || 0}
            duration={2000}
          />
          <div className={classes.sub_content}>
            <span className={classes.sub_score}>{brandIndex?.rank}</span>
            <hr className={classes.divider} />
            <span className={classes.sub_score}>
              {brandIndex?.favorability}
            </span>
          </div>
        </div>
      </>
    );
  }

  if (competitor && brandIndex?.error) {
    cardContent = (
      <ErrorView
        title="An error occured"
        message="Something went wrong"
        retry
        onRetry={() => onRetry(index)}
      />
    );
  }

  let compeititorCard = "";
  if (cardContent) {
    compeititorCard = (
      <MUICard
        variant="elevated"
        elevation={0}
        borderRadius={3}
        className={classes.card}
        width={"90%"}
      >
        {cardContent}
      </MUICard>
    );
  }

  return (
    <div
      className={classes.container}
      style={{
        backgroundColor: compeititorCard ? "#eff4f8" : "inherit",
      }}
    >
      <Modal
        width={1200}
        open={showBrandIndexBreakups}
        handleClose={() => setShowBrandIndexBreakups(false)}
      >
        <BrandIndexBreakups
          data={brandIndex?.extras}
          isOpen={showBrandIndexBreakups}
          type={discoveryCtx.type}
        />
      </Modal>
      {compeititorCard}
      {competitor && !brandIndex?.error && !brandIndex.total && (
        <Skeleton
          variant="rectangular"
          style={{
            zIndex: 1,
            flexGrow: 1,
            height: 220,
            flexBasis: "calc(50% - 12.5px)",
            backgroundColor: "rgb(0 0 0 / 11%)",
          }}
        />
      )}
    </div>
  );
}
